<template>
	<div class="articleManage">

		<div class="breadcrumb">内容管理
			<el-button class="right_f" type="primary" @click="goNewArticle">新增</el-button>
			<el-button class="right_f" style="right:50px" type="primary" @click="goNewArticle1">新增富文本</el-button>
		</div>

		<div class="search">
			<el-select v-model="classes">
				<el-option label="全部类别" value='0'></el-option>
				<el-option v-for='item in categories' :label='item.label' :value='item.value' :key='item.value'>
				</el-option>
			</el-select>

			<el-select v-model="status">
				<el-option label="全部状态" value='0'></el-option>
				<el-option label="已发布" value='2'></el-option>
				<el-option label="草稿" value='1'></el-option>
				<el-option label="已置顶" value='3'></el-option>
				<el-option label="已撤销" value='9'></el-option>
			</el-select>

			<div class="el-input">
				<input type="text" placeholder="搜索标题关键字" class="el-input__inner" v-model="keyWord"
					@keyup.enter="search"></input>
			</div>

			<el-button type="primary" @click="search">搜索</el-button>
		</div>

		<div class="com-list">
			<el-table v-show="articles.length > 0" :data="articles" style="overflow-x: auto;">
				<el-table-column prop="index" label="序号" width="80">
				</el-table-column>
				<el-table-column prop="id" label="文章id">
				</el-table-column>
				<el-table-column prop="applicableCampus" label="适用学校">
				</el-table-column>
				<el-table-column prop="articleName" label="标题" show-overflow-tooltip width="350">
				</el-table-column>
				<el-table-column prop="class" label="类别">
				</el-table-column>
				<el-table-column prop="readNum" label="阅读">
				</el-table-column>
				<el-table-column prop="likeAndNot" label="顶/踩">
				</el-table-column>
				<el-table-column prop="status" label="状态">
				</el-table-column>
				<el-table-column inline-template label="发布" width="150">
					<div>
						<div>{{ row.publisher }}</div>
						<div>{{ row.publishTime }}</div>
					</div>
				</el-table-column>
				<el-table-column inline-template label="创建" width="150">
					<div>
						<div>{{ row.creater }}</div>
						<div>{{ row.createTime }}</div>
					</div>
				</el-table-column>
				<el-table-column inline-template label="操作" width="130">
					<div>
						<el-button class="option" type="text" v-if="row.status !== '草稿' && row.status !== '已撤销'"
							@click="showDetail(row)">详情</el-button>
						<el-button class="option" type="text" v-if="row.status == '草稿' || row.status == '已撤销'"
							@click="editNew(row)">编辑</el-button>
						<el-button class="option" type="text" v-if="row.status == '草稿' || row.status == '已撤销'"
							@click="editNew1(row)">富文本编辑</el-button>
						<el-button class="option" type="text" v-if="row.status == '草稿' || row.status == '已撤销'"
							@click="issue(row)">发布</el-button>
						<el-button class="option" type="text" v-if="row.status == '草稿' || row.status == '已撤销'"
							@click="deleteConfirm(row)">删除</el-button>
						<el-button class="option" type="text" v-if="row.status !== '草稿' && row.status !== '已撤销'"
							@click="noIssue(row, 1)">撤销发布</el-button>
						<el-button class="option" type="text" v-if="row.status == '已发布'" @click="toTop(row, 3)">置顶
						</el-button>
						<el-button class="option" type="text" v-if="row.status == '已置顶'" @click="noTop(row, 2)">取消置顶
						</el-button>
					</div>
				</el-table-column>
			</el-table>
		</div>

		<div class="pagination">
			<el-pagination v-show="this.totalCount > 0" layout="prev, pager, next, jumper" :page-size="20"
				:current-page="currentPage" :total="totalCount" @current-change="handleCurrentChange">
			</el-pagination>
		</div>
	</div>
</template>
<script>
import { mapState } from 'vuex'

export default {
	data() {
		return {
			classes: '0',
			categories: [],
			status: '0',
			keyWord: '',
			list: [],
			articles: [],
			currentPage: 1,
			totalCount: 0
		}
	},
	computed: mapState({ user: state => state.user }),
	mounted() {
		//获取文章类别&请求文章列表
		this.getClasses();

	},
	methods: {
		/**
		 * 获取文章类别
		**/
		getClasses() {
			this.$http({
				method: 'POST',
				url: this.$util.domain + '/adminapi/v1/operate/news/categories'
			}).then(response => {
				if (response.data.error === 10000) {
					let categoryList = response.data.data;
					this.categories = [];
					for (let i = 0; i < categoryList.length; i++) {
						let label = categoryList[i].categoryName;
						let value = categoryList[i].id + "";

						this.categories.push({ label, value });
					}

				}

				//解析页面参数，请求文章列表
				this.paramAndGet();

			}, response => {
				this.$util.errorMsg(response.data.message);
			})
		},

		/**
		 * 解析参数，请求文章
		**/
		paramAndGet() {
			let url = window.location.href;

			if (url.indexOf('?') !== -1) {

				this.classes = this.$util.getUrlParam('classes');
				this.status = this.$util.getUrlParam('status');
				this.keyWord = decodeURI(this.$util.getUrlParam('keyWord'));
			}
			this.getList();
		},

		/**
		 *请求分页数据
		**/
		handleCurrentChange(val) {
			this.currentPage = val;
			this.getList();
		},

		goNewArticle() {
			location.href = '/#/yunying/article/newArticle';
		},

		goNewArticle1() {
			location.href = '/#/yunying/about/about';
		},

		/**
		 *请求文章列表
		 * @param {Number} categoryId
		 * @param {Number} status
		 * @param {String} keyword
		 * @param {Number} pageNumber
		 * @param {Number} pageSize
		**/
		getList() {
			this.$http({
				method: 'POST',
				url: this.$util.domain + '/adminapi/v3/operate/news/list',
				body: JSON.stringify({
					categoryId: this.classes * 1,
					status: this.status * 1,
					keyword: this.keyWord,
					pageNum: this.currentPage,
					pageSize: 20,
					author: "",
					contentType: "-1",
					beginAt: null,
					endAt: null
				})
			}).then(response => {
				if (response.data.error === 10000) {
					let data = response.data.data;

					this.list = data.list || [];
					this.totalCount = data.totalCount;

					this.getArticles();
				}

			}, (response) => {
				this.$util.errorMsg(response.data.message);
			})
		},

		getArticles() {
			this.articles = [];

			for (let i = 0; i < this.list.length; i++) {
				let $index = (this.currentPage - 1) * 20 + i + 1;
				let $id = this.list[i].id;
				let $articleName = this.list[i].title;
				let $class = this.list[i].category;
				let $readNum = this.list[i].readCount;
				let $likeAndNot = this.list[i].likeCount + '/' + this.list[i].unlikeCount;
				let $creater = this.list[i].creater;
				let $createTime = new Date(this.list[i].createTime).format('yyyy.MM.dd hh:mm');
				let $applicableCampus = this.list[i].applicableCampus == 1 ? "部分" : "全部";
				let $publisher;
				let $publishTime;
				let $status = this.list[i].status;

				if ($status === 1) {
					$publisher = '';
					$publishTime = '';
				} else {
					$publisher = this.list[i].publisher;
					$publishTime = new Date(this.list[i].publishTime).format('yyyy.MM.dd hh:mm');
				}

				switch ($status) {
					case 1:
						$status = '草稿';
						break;
					case 2:
						$status = '已发布';
						break;
					case 3:
						$status = '已置顶';
						break;
					case 9:
						$status = '已撤销';
						break;
				};

				this.articles.push({
					index: $index,
					id: $id,
					applicableCampus: $applicableCampus,
					articleName: $articleName,
					class: $class,
					readNum: $readNum,
					likeAndNot: $likeAndNot,
					status: $status,
					creater: $creater,
					createTime: $createTime,
					publisher: $publisher,
					publishTime: $publishTime
				})
			}
		},

		/**
		 *搜索文章列表
		**/
		search() {
			let params = {
				classes: this.classes,
				status: this.status,
				keyWord: encodeURI(this.keyWord)
			}
			this.$util.refreshTo("/#/yunying/article/articleManage", params);

			this.getClasses();
		},


		/**
		 * 发布文章
		 * @param {Number} newsId
		 * @param {Number} publishUid
		**/
		publish(row) {
			let newsId = row.id;
			this.$http({
				method: 'POST',
				url: this.$util.domain + '/adminapi/v1/operate/news/publish',
				body: JSON.stringify({
					newsId: newsId,
					publishUid: this.user.userId
				})
			}).then(response => {

				if (response.data.error !== 10000) {
					this.$util.errorMsg('操作失败');
				} else {
					location.reload();
				}

			}, (response) => {
				this.$util.errorMsg(response.data.message);
			})
		},

		/**
		 * 发布弹窗
		**/
		issue(row) {

			this.$confirm('确定要发布吗？发布后该篇会变成“已发布”状态，且用户端将会看到该篇内容', '发布', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.publish(row);
			}).catch(() => {
				//do nothing
			})
		},

		/**
		 * 删除文章弹窗
		 * @param row
		**/
		deleteConfirm(row) {
			this.$confirm('确定要删除吗？删除后不可恢复，请谨慎删除。', '删除', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.deleteNews(row);
			}).catch(() => {
				//do nothing
			})
		},

		/**
		 * 删除文章
		 * @param {Number} newsId
		**/
		deleteNews(row) {
			let newsId = row.id

			this.$http({
				method: 'POST',
				url: this.$util.domain + '/adminapi/v1/operate/news/delete',
				body: JSON.stringify({
					id: newsId
				})
			}).then(response => {

				if (response.data.error === 10000) {
					window.location.reload();

				} else {
					this.$util.errorMsg('操作失败');
				}

			}, response => {
				this.$util.errorMsg(response.data.message);
			})
		},

		/**
		 * 撤销发布
		**/
		noIssue(row) {

			this.$confirm('确定要撤销发布吗？撤销发布后该篇会变成“已撤销”状态，且用户端将无法看到该篇内容', '发布', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.changeStatus(row, 9);
			}).catch(() => {
				//do nothing
			})
		},

		/**
		 * 置顶
		**/
		toTop(row) {
			this.$confirm('确定将该篇置顶吗？置顶功能会对用户端及管理后台同时生效，置顶后可以通过“取消置顶”按钮取消', '置顶', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.changeStatus(row, 3);
			}).catch(() => {
				//do nothing
			})
		},

		/**
		 * 撤销置顶
		**/
		noTop(row) {
			this.$confirm('确定将该篇取消置顶吗？取消置顶会使该篇根据发布或创建时间恢复至原位置，且对用户端及本管理后台同时生效', '取消置顶', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.changeStatus(row, 2);
			}).catch(() => {
				//do nothing
			})
		},

		/**
		 * 改变文章状态
		 * @param {Number} newsId
		 * @param {Number} newStatus
		**/
		changeStatus(row, newStatus) {
			let newsId = row.id;
			this.$http({
				method: 'POST',
				url: this.$util.domain + '/adminapi/v1/operate/news/change_status',
				body: JSON.stringify({ newsId, newStatus })
			}).then(response => {
				if (response.data.error !== 10000) {
					this.$util.errorMsg('操作失败');
				} else {
					location.reload();
				}
			}, (response) => {
				this.$util.errorMsg(response.data.message);
			})
		},

		/**
		 * 编辑
		 * @param {Number} newsId
		**/
		editNew(row) {
			location.href = '/#/yunying/article/newArticle?newsId=' + row.id;
		},

		editNew1(row) {
			location.href = '/#/yunying/about/about?newsId=' + row.id;
		},
		/**
		 * 详情
		 * @param {Number} newsId
		**/
		showDetail(row) {
			location.href = '/#/yunying/article/articleDetail?newsId=' + row.id
		},

		/**
		 * 评论管理
		 * @param {Number} newsId
		**/
		goComment(row) {
			location.href = `/#/yunying/article/commentManage?newsId=${row.id}&commentStatus=2&order=2&keyWord=`;
		}
	}
}
</script>

<style>
.articleManage .el-select {
	display: inline-block;
}

.articleManage .el-input {
	display: inline-block;
	width: 200px;
}

.articleManage .el-button {
	display: inline-block;
}

.articleManage .el-button+.el-button {
	margin-left: 0;
}

.search {
	margin-left: 30px;
}

.articles {
	margin-top: 20px;
}
</style>


// WEBPACK FOOTER //
// articleManage.vue?71ec85cb